import React from 'react';
import {
  Card,
  CardBody,
  CardHeader,
  Label,
  FormGroup,
  Form,
  Input,
  Button,
} from 'reactstrap';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import { actionUpdatePatientEmail } from 'store/actions/usersActions';


const PatientEmailForm = ({ userData }) => {
  const dispatch = useDispatch();
  
  const { register, handleSubmit } = useForm();
  const history = useHistory();

  /**
   * Reduces flat form fields into an array of `{ practice, ext_ref }` objects
   * and dispatches the update action.
   *
   * @param {Object} data - react-hook-form collected values.
   */
  const onSubmit = (data) => {
    dispatch(actionUpdatePatientEmail(userData.auth_user_id, data.email));
  };

  return (
    <Card>
        <CardHeader>
            {`${userData?.firstName} ${userData?.lastName} Email edition form`}
        </CardHeader>
        <CardBody>
            <Form id="email-edit-form" onSubmit={handleSubmit(onSubmit)}>

                <Label>Email</Label>
                <FormGroup>
                    <Input
                        type="text"
                        name={`email`}
                        defaultValue={userData.email}
                        required
                        innerRef={register}
                    />
                </FormGroup>

            </Form>

            <Button form="email-edit-form" size="sm" color="info" type="submit">
                Update
            </Button>

            <Button
                size="sm"
                color="danger"
                onClick={(e) => {
                    e.preventDefault();
                    history.goBack();
                }}
            >
                Cancel
            </Button>
        </CardBody>
    </Card>
  );
};

export default PatientEmailForm;